import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/home/HomePage';
import { SearchPage } from './pages/search/SearchPage';
import { PropertyDetailPage } from './pages/property/PropertyDetailPage';
import { AddPropertyPage } from './pages/property/AddPropertyPage';
import { CitiesPage } from './pages/cities/CitiesPage';
import { CityDetailPage } from './pages/cities/CityDetailPage';
import { BlogPage } from './pages/blog/BlogPage';
import { ArticleDetailPage } from './pages/blog/ArticleDetailPage';
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { AgenciesPage } from './pages/agencies/AgenciesPage';
import { AgencyDetailPage } from './pages/agencies/AgencyDetailPage';
import PriceMapPage from './pages/prices/PriceMapPage';
import EstimatePage from './pages/estimate/EstimatePage';
import ComparePage from './pages/compare/ComparePage';
import BlogAdminPage from './pages/blog/BlogAdminPage';
import AlertsPage from './pages/dashboard/AlertsPage';
import AdminPage from './pages/admin/AdminPage';
import './App.css';

// Layout with navbar and footer
const MainLayout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);

// Auth layout without navbar/footer
const AuthLayout = ({ children }) => (
  <div className="min-h-screen">{children}</div>
);

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Auth routes */}
            <Route path="/login" element={<AuthLayout><LoginPage /></AuthLayout>} />
            <Route path="/register" element={<AuthLayout><RegisterPage /></AuthLayout>} />

            {/* Main routes */}
            <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
            <Route path="/search" element={<MainLayout><SearchPage /></MainLayout>} />
            <Route path="/property/:id" element={<MainLayout><PropertyDetailPage /></MainLayout>} />
            <Route path="/add-property" element={<MainLayout><AddPropertyPage /></MainLayout>} />
            <Route path="/cities" element={<MainLayout><CitiesPage /></MainLayout>} />
            <Route path="/cities/:cityName" element={<MainLayout><CityDetailPage /></MainLayout>} />
            <Route path="/blog" element={<MainLayout><BlogPage /></MainLayout>} />
            <Route path="/blog/:slug" element={<MainLayout><ArticleDetailPage /></MainLayout>} />
            <Route path="/agencies" element={<MainLayout><AgenciesPage /></MainLayout>} />
            <Route path="/agencies/:id" element={<MainLayout><AgencyDetailPage /></MainLayout>} />
            <Route path="/prix-immobilier" element={<MainLayout><PriceMapPage /></MainLayout>} />
            <Route path="/estimer" element={<MainLayout><EstimatePage /></MainLayout>} />
            <Route path="/comparer" element={<MainLayout><ComparePage /></MainLayout>} />
            <Route path="/blog-admin" element={<MainLayout><AdminPage /></MainLayout>} />
            <Route path="/admin" element={<MainLayout><AdminPage /></MainLayout>} />
            <Route path="/alerts" element={<MainLayout><AlertsPage /></MainLayout>} />
            
            {/* Dashboard routes */}
            <Route path="/dashboard" element={<MainLayout><DashboardPage /></MainLayout>} />
            <Route path="/my-properties" element={<MainLayout><DashboardPage /></MainLayout>} />
            <Route path="/favorites" element={<MainLayout><DashboardPage /></MainLayout>} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
